export default "<div class=\"text-center\">\r\n\t<h1 class=\"text-success\">\r\n\t\t<i class=\"fas fa-sync fa-spin\"></i>\r\n\t</h1>\r\n</div>\r\n";